import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

import { theme } from './tailwind-theme'

function formatColors() {
  const colors = []
  for (const [key, color] of Object.entries(theme.colors)) {
    if (typeof color === 'string') {
      colors.push(key)
    }
  }
  return colors
}

const customTwMerge = extendTailwindMerge({
  override: {
    classGroups: {
      'font-size': [
        {
          text: Object.keys(theme.fontSize),
        },
      ],
    },
  },
  extend: {
    theme: {
      colors: formatColors(),
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs))
}
